import type { Order } from '@backmarket/http-api/src/api-specs-payment/payment/payment-result.types'

import { isPaymentSuccessPartnerPromoCode } from '~/api/partner-promo-code/types'

export function getVisibleByVerizonPromoCode(orders: Order[]): string | null {
  let partnerPromoCode = null

  orders.forEach((order) =>
    order.orderlines.forEach((orderline) => {
      if (
        orderline.partnerPromoCode &&
        orderline.partnerPromoCode.partnerName === 'VISIBLE' &&
        isPaymentSuccessPartnerPromoCode(orderline.partnerPromoCode)
      ) {
        partnerPromoCode = orderline.partnerPromoCode.codeValue
      }
    }),
  )

  return partnerPromoCode
}
